// For empty messages, you have tu use ' '
// '' is evaluated as false and show the default message

export const EN_VOCABULARY = {
  // Custom translations
  'Enter your username': 'Username',
  'Enter your password': 'Password',
  'Sign In': 'Connexion',
  'Reset password': 'Click here',
  'Forget your password? ': 'Forgot your username/password ? ',
  'No account? ': ' ',
  'Have an account? ': ' ',
  'Username/client id combination not found.': 'USERNAME not found',
  'Send Code': 'Send email',
  'Resend email': 'Resend email',
  'Code Label': 'Enter the verification code reveived by email',
  'New Password Label': 'Enter your new password',
};

export const FR_VOCABULARY = {
  // Base translations (they do not apply in staging if not explicitely set)
  Hello: 'Bonjour',
  'Loading...': 'Chargement...',
  'Sign In with Amazon': 'Se connecter avec Amazon',
  'Sign In with Facebook': 'Se connecter avec Facebook',
  'Sign In with Google': 'Se connecter avec Google',
  'Sign in with AWS': 'Se connecter avec AWS',
  'Sign Up': "S'inscrire",
  'Sign Out': 'Déconnexion',
  'Forgot Password': 'Mot de passe oublié',
  Username: "Nom d'utilisateur",
  Password: 'Mot de passe',
  'Change Password': 'Modifier le mot de passe',
  Change: 'Modifier',
  'New Password': 'Nouveau mot de passe (6 caractères minimum)',
  Email: 'Email',
  'Phone Number': 'Numéro de téléphone',
  'Confirm a Code': 'Confirmer un code',
  'Confirm Sign In': 'Confirmer la connexion',
  'Confirm Sign Up': "Confirmer l'inscription",
  'Back to Sign In': 'Retour à la connexion',
  Send: 'Envoyer',
  'Send Code': "Envoyer l'email",
  Confirm: 'Confirmer',
  SMS: 'SMS',
  'Confirm SMS Code': 'Confirmer le code SMS',
  'Confirm TOTP Code': 'Confirmer le code TOTP',
  'Resend a Code': 'Renvoyer un code',
  Submit: 'Valider',
  Skip: 'Passer',
  Verify: 'Vérifier',
  'Verify Contact': 'Vérifier le contact',
  Code: 'Code',
  'Confirmation Code': 'Code de confirmation',
  'Account recovery requires verified contact information':
    'La récupération du compte nécessite des informations de contact vérifiées',

  'User does not exist': "L'utilisateur n'existe pas",
  'User already exists': "L'utilisateur existe déjà",
  'Incorrect username or password': 'Identifiant ou mot de passe incorrect',
  'Invalid email address format.': "Format d'email invalide",
  'Invalid password format': 'Format de mot de passe invalide',
  'Invalid phone number format':
    'Format de numéro de téléphone invalide. Veuillez utiliser un format +12345678900',
  'Username/client id combination not found.': "Ce USERNAME n'existe pas",
  'Network error': 'Erreur réseau',
  'Sign in to your account': 'Connexion à votre compte',
  'Create account': 'Créer un compte',
  'Sign in': 'Se connecter',
  'Create a new account': 'Créer un nouveau compte',
  'Reset your password': 'Réinitialisez votre mot de passe',
  'Enter your phone number': 'Saisissez votre numéro de téléphone',
  'Enter your email': 'Email',
  'Enter your code': 'Saisissez cotre code de confirmation',
  'Lost your code? ': 'Vous avez perdu votre code ? ',
  'Resend email': "Renvoyer l'email",
  or: 'ou',
  'An account with the given email already exists.':
    'Un utilisateur avec cette adresse email existe déjà.',
  'Username cannot be empty': "Le nom d'utilisateur doit être renseigné",

  // Custom translations
  'Enter your username': "Nom d'utilisateur",
  'Enter your password': 'Mot de passe',
  'Create Account': 'Valider',
  'Sign In': 'Connexion',
  'Reset password': 'Cliquez-ici',
  'Forget your password? ': 'Identifiant/mot de passe oublié ? ',
  'No account? ': ' ',
  'Have an account? ': ' ',
  'Code Label': 'Entrer le code de vérification reçu par email',
  'New Password Label': 'Entrer le nouveau mot de passe',
};
